/**
 * isString: Check if value is a String
 *
 * A string is always a string so this one is easy. Except if called with new (new String) typeof will instead return "object".
 * So to also include those strings instanceof can be used.
 *
 * @return {Boolean}
 */

export const isString = (value) => {
  return typeof value === 'string' || value instanceof String
}
